// Superadmin Level Permissions
export const SUPERADMIN_PERMISSIONS = {
  // User Management
  ADD_NEW_USER: "SLPAD",
  ACCESS_USER: "SLPAC",
  ACCESS_USERS: "U",

  // Superadmin Settings
  ACCESS_SUPERADMIN_STORE_SETTING: "SSS",
  ACCESS_SUPERADMIN_PERMISSIONS: "SP",

  // Support
  ACCESS_SUPPORT: "SUPM",
  ACCESS_SUPPORT_DETAILS: "SD",
  EDIT_SUPPORT_DETAILS: "ESD",

  // Merchants Management
  ACCESS_MERCHANTS: "UM",
  ADD_MERCHANTS: "ADDM",
  EDIT_MERCHANTS: "EDITM",
  DELETE_STORES: "DELM",

  // Live Store
  ACCESS_LIVE_STORE: "ULS",
  EDIT_LIVE_STORE: "ELS",
  VIEW_LIVE_STORE: "VLS",
  DISAPPROVE_LIVE_STORE: "DAS",
  EXPORT_LIVE_STORE: "EXLS",

  // Inactive Store
  ACCESS_INACTIVE_STORE: "UILS",
  ADD_INACTIVE_STORE: "AINS",
  EDIT_INACTIVE_STORE: "EINS",
  VIEW_INACTIVE_STORE: "VINLS",
  APPROVE_INACTIVE_STORE: "AIAS",
  EXPORT_INACTIVE_STORE: "EXINS",

  // Quickvee Customer
  ACCESS_QUICKVEE_CUSTOMER: "QC",

  // Refund Request
  ACCESS_REFUND_REQUEST: "RER",
  REFUND_REQUEST_STATUS: "RRS",

  // Order Count
  ACCESS_ORDER_COUNT: "OC",

  // Default Category
  ACCESS_DEFAULT_CATEGORY: "DC",
  ADD_DEFAULT_CATEGORY: "ADC",
  EDIT_DEFAULT_CATEGORY: "EDC",
  DELETE_DEFAULT_CATEGORY: "DDC",
  STATUS_DEFAULT_CATEGORY: "SDC",

  // Feature Store
  ACCESS_FEATURE_STORE: "FS",
  ADD_FEATURE_STORE: "AFS",
  EDIT_FEATURE_STORE: "EFS",
  DELETE_FEATURE_STORE: "DFS",
  SORT_FEATURE_STORE: "SFS",

  // Configure Category
  ACCESS_CONFIGURE_CATEGORY: "CONC",
  ADD_CONFIGURE_CATEGORY: "ADDCC",
  EDIT_CONFIGURE_CATEGORY: "EDITC",
  DELETE_CONFIGURE_CATEGORY: "DCC",
  SORT_CONFIGURE_CATEGORY: "SORTC",
  STATUS_CONFIGURE_CATEGORY: "STACC",

  // Quickvee Custom
  ACCESS_QUICKVEE_CUSTOM: "CUS",
  ADD_QUICKVEE_CUSTOM: "ACUS",
  EDIT_QUICKVEE_CUSTOM: "ECUS",
  DELETE_QUICKVEE_CUSTOM: "DCUS",
  STATUS_QUICKVEE_CUSTOM: "SCUS",

  // Newsletter
  ACCESS_NEWSLETTER: "NS",
  STATUS_NEWSLETTER: "SNS",
  DELETE_NEWSLETTER: "DNS",

  INVENTORY_DUPLICATE: "IVD",
  CATEGORY_DUPLICATE: "CATD",
  PRODUCT_DUPLICATE: "PROD",

  // Main Permissions
  ACCESS_MAIN_PERMISSIONS: "MAP",
  ADD_MAIN_PERMISSIONS: "AMAP",
  EDIT_MAIN_PERMISSIONS: "EMAP",
  SORT_MAIN_PERMISSIONS: "SMAP",

  // Sub Permissions
  ACCESS_SUB_PERMISSIONS: "SUBP",
  ADD_SUB_PERMISSIONS: "ASUB",
  EDIT_SUB_PERMISSIONS: "ESUB",
  DELETE_SUB_PERMISSIONS: "DSUB",
  SORT_SUB_PERMISSIONS: "SSUB",

  // Inventory Export
  ACCESS_INVENTORY_EXPORT: "IVE",

  // Order Retrieve
  ACCESS_ORDER_RETRIEVE: "OR",

  // All Inventory Update
  ACCESS_ALL_INVENTORY_UPDATE: "IVU",

  // Superadmin List
  ACCESS_SUPERADMIN_LIST: "SL",
  ADD_SUPERADMIN_USER: "ADDSU",
  EDIT_SUPERADMIN_USER: "EDTSU",
  DELETE_SUPERADMIN_USER: "DSU",
  PERMISSIONS_SUPERADMIN_USER: "PSU",

  // Telnyx Mass SMS
  ACCESS_TELNYX_MASS_SMS: "BSS",


  //  Feature Announcements
  ACCESS_FEATURE_ANNOUNCEMENTS: "FA",
  ADD_FEATURE_ANNOUNCEMENTS: "AFA",
  EDIT_FEATURE_ANNOUNCEMENTS: "EFA",
  DELETE_FEATURE_ANNOUNCEMENTS: "DFA",
  CHANGE_FEATURE_ANNOUNCEMENTS: "CFA",

  // Restricted Keywords
  ACCESS_RESTRICTED_KEYWORDS: "RKEY",
  ADD_RESTRICTED_KEYWORDS: "ARKEY",
  EDIT_RESTRICTED_KEYWORDS: "ERKEY",
  DELETE_RESTRICTED_KEYWORDS: "DRKEY",

  ACCESS_MERCHANT_EXPORT: "AME",
  ACCESS_CUSTOMER_EXPORT: "ACE",
  ACCESS_ORDER_WISE_EXPORT: "AOWE",
  ACCESS_ITEM_WISE_EXPORT: "AIWE",
  ACCESS_PRODUCT_PROFITABLE_EXPORT: "APPE",
  ACCESS_TIP_REPORT_EXPORT: "ATRE",
  ACCESS_PURCHASE_ORDER_REPORT_EXPORT: "APORE",
  ACCESS_SALES_BY_CATEGORY_PER_EMPLOYEE_EXPORT: "ASBCE",
  ACCESS_SALES_BY_TENDER_EXPORT: "ASBTE",
};

// Route key → permission code mapping
// Routes NOT listed here are open to all logged-in superadmins
export const ROUTE_PERMISSIONS = {
  // Users
  merchant: SUPERADMIN_PERMISSIONS.ACCESS_MERCHANTS,
  addMerchant: SUPERADMIN_PERMISSIONS.ADD_MERCHANTS,
  editMerchant: SUPERADMIN_PERMISSIONS.EDIT_MERCHANTS,
  // verified and unverified are open to all users (no restriction)
  customer: SUPERADMIN_PERMISSIONS.ACCESS_QUICKVEE_CUSTOMER,
  "merchant-details": SUPERADMIN_PERMISSIONS.ACCESS_MERCHANTS,
  superadmin_list: SUPERADMIN_PERMISSIONS.ACCESS_SUPERADMIN_LIST,
  "superadmin-add": SUPERADMIN_PERMISSIONS.ADD_SUPERADMIN_USER,
  "superadmin-edit": SUPERADMIN_PERMISSIONS.EDIT_SUPERADMIN_USER,
  "permission-add": SUPERADMIN_PERMISSIONS.PERMISSIONS_SUPERADMIN_USER,
  "permission-edit": SUPERADMIN_PERMISSIONS.PERMISSIONS_SUPERADMIN_USER,

  // Store Settings
  defaults: SUPERADMIN_PERMISSIONS.ACCESS_DEFAULT_CATEGORY,
  "add-defaults": SUPERADMIN_PERMISSIONS.ADD_DEFAULT_CATEGORY,
  "edit-defaults": SUPERADMIN_PERMISSIONS.EDIT_DEFAULT_CATEGORY,
  banners: SUPERADMIN_PERMISSIONS.ACCESS_FEATURE_STORE,
  "add-banners": SUPERADMIN_PERMISSIONS.ADD_FEATURE_STORE,
  "edit-banners": SUPERADMIN_PERMISSIONS.EDIT_FEATURE_STORE,

  // Permissions
  create_permission: SUPERADMIN_PERMISSIONS.ACCESS_SUB_PERMISSIONS,
  create_main_permission: SUPERADMIN_PERMISSIONS.ACCESS_MAIN_PERMISSIONS,

  // Configure / Custom
  Configure_Categories: SUPERADMIN_PERMISSIONS.ACCESS_CONFIGURE_CATEGORY,
  "Quickvee-Custom": SUPERADMIN_PERMISSIONS.ACCESS_QUICKVEE_CUSTOM,
  "Quickvee-Custom-add": SUPERADMIN_PERMISSIONS.ADD_QUICKVEE_CUSTOM,
  "Quickvee-Custom-edit": SUPERADMIN_PERMISSIONS.EDIT_QUICKVEE_CUSTOM,

  // Newsletter
  newsletter: SUPERADMIN_PERMISSIONS.ACCESS_NEWSLETTER,
  "newsletter-subscribed": SUPERADMIN_PERMISSIONS.ACCESS_NEWSLETTER,

  // Duplicates
  "inverntory-duplicate": SUPERADMIN_PERMISSIONS.INVENTORY_DUPLICATE,
  "category-duplicate": SUPERADMIN_PERMISSIONS.CATEGORY_DUPLICATE,
  "product-duplicate": SUPERADMIN_PERMISSIONS.PRODUCT_DUPLICATE,

  // Inventory / Orders
  "invertory-export": SUPERADMIN_PERMISSIONS.ACCESS_INVENTORY_EXPORT,
  "order-retrieve": SUPERADMIN_PERMISSIONS.ACCESS_ORDER_RETRIEVE,
  "order-count": SUPERADMIN_PERMISSIONS.ACCESS_ORDER_COUNT,

  // Support
  "support-details": SUPERADMIN_PERMISSIONS.ACCESS_SUPPORT_DETAILS,
  "all-inventory-update": SUPERADMIN_PERMISSIONS.ACCESS_ALL_INVENTORY_UPDATE,

  // Refund
  "refund-request": SUPERADMIN_PERMISSIONS.ACCESS_REFUND_REQUEST,

  //Telnyx Mass SMS
  "bulk-sms-system": SUPERADMIN_PERMISSIONS.ACCESS_TELNYX_MASS_SMS,


  //  Feature Announcements
  "Feature-Announcements": SUPERADMIN_PERMISSIONS.ACCESS_FEATURE_ANNOUNCEMENTS,
  "Feature-Announcements-add": SUPERADMIN_PERMISSIONS.ADD_FEATURE_ANNOUNCEMENTS,
  "Feature-Announcements-edit": SUPERADMIN_PERMISSIONS.EDIT_FEATURE_ANNOUNCEMENTS,

  // Restricted Keywords
  "restricted-keywords": SUPERADMIN_PERMISSIONS.ACCESS_RESTRICTED_KEYWORDS,
  "add-restricted-keyword": SUPERADMIN_PERMISSIONS.ADD_RESTRICTED_KEYWORDS,
  "edit-restricted-keyword": SUPERADMIN_PERMISSIONS.EDIT_RESTRICTED_KEYWORDS,

  "customer-export": SUPERADMIN_PERMISSIONS.ACCESS_CUSTOMER_EXPORT,
  "order-wise-export": SUPERADMIN_PERMISSIONS.ACCESS_ORDER_WISE_EXPORT,
  "item-wise-export": SUPERADMIN_PERMISSIONS.ACCESS_ITEM_WISE_EXPORT,
  "product-profitability-export": SUPERADMIN_PERMISSIONS.ACCESS_PRODUCT_PROFITABLE_EXPORT,
  "tip-report-export": SUPERADMIN_PERMISSIONS.ACCESS_TIP_REPORT_EXPORT,
  "purchase-order-report-export":
    SUPERADMIN_PERMISSIONS.ACCESS_PURCHASE_ORDER_REPORT_EXPORT,
  "sales-by-category-per-employee-export":
    SUPERADMIN_PERMISSIONS.ACCESS_SALES_BY_CATEGORY_PER_EMPLOYEE_EXPORT,
  "sales-by-tender-export": SUPERADMIN_PERMISSIONS.ACCESS_SALES_BY_TENDER_EXPORT,
};

const PERMISSION_LABEL_OVERRIDES = {
  ACCESS_TELNYX_MASS_SMS: "Bulk SMS System",
  ACCESS_RESTRICTED_KEYWORDS: "Restricted Keywords",
  CHANGE_FEATURE_ANNOUNCEMENTS: "Status Feature Announcements",
  ACCESS_MERCHANT_EXPORT: "Access Merchants Export",
  ACCESS_PRODUCT_PROFITABLE_EXPORT: "Access Product Profitability Export",
  ACCESS_SALES_BY_CATEGORY_PER_EMPLOYEE_EXPORT:
    "Sales by Category Per Employee - Export",
  INVENTORY_DUPLICATE: "Inventory Duplicate",
  CATEGORY_DUPLICATE: "Category Duplicate",
  PRODUCT_DUPLICATE: "Product Duplicate",
};

const humanizePermissionKey = (key) => {
  if (PERMISSION_LABEL_OVERRIDES[key]) return PERMISSION_LABEL_OVERRIDES[key];
  return key
    .toLowerCase()
    .split("_")
    .filter(Boolean)
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
};

export const SUPERADMIN_PERMISSION_LABEL_BY_CODE = Object.fromEntries(
  Object.entries(SUPERADMIN_PERMISSIONS).map(([key, code]) => [
    String(code),
    humanizePermissionKey(key),
  ])
);

export function getSuperadminPermissionLabels(permissions) {
  const raw = Array.isArray(permissions)
    ? permissions
    : String(permissions ?? "").split(",");
  const seen = new Set();
  const labels = [];

  raw.forEach((item) => {
    const code = String(item ?? "").trim();
    if (!code || seen.has(code)) return;
    seen.add(code);
    labels.push({
      code,
      label: SUPERADMIN_PERMISSION_LABEL_BY_CODE[code] || code,
    });
  });

  return labels;
}

export const normalizePermissionName = (name) =>
  String(name || "")
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, " ")
    .trim();

export const permissionLabels = (item) =>
  [item?.sub_permission, item?.alternateName]
    .map(normalizePermissionName)
    .filter(Boolean);

export const PERMISSION_GROUPS = [
  {
    id: "admin",
    name: "Admin & Access Control",
    desc: "Users, superadmins and permission setup. IT only.",
    risk: "high",
    subs: [
      {
        name: "Main Permissions",
        permissions: [
          "Access Main Permissions",
          "Add Main Permissions",
          "Edit Main Permissions",
          "Sort Main Permissions",
        ],
      },
      {
        name: "Sub Permissions",
        permissions: [
          "Access Sub Permissions",
          "Add Sub Permissions",
          "Edit Sub Permissions",
          "Delete Sub Permissions",
          "Sort Sub Permissions",
        ],
      },
      {
        name: "Superadmin",
        permissions: [
          "Access Superadmin List",
          "Add Superadmin User",
          "Edit Superadmin User",
          "Delete Superadmin User",
          "Permissions Superadmin User",
          "Access Superadmin Permissions",
          "Access Superadmin Store Setting",
        ],
      },
      {
        name: "Users",
        permissions: ["Add New User", "Access User", "Access Users"],
      },
      {
        name: "Stores",
        permissions: ["Delete Stores"],
      },
    ],
  },
  {
    id: "merchant",
    name: "Merchant & Store Onboarding",
    desc: "Create merchants, manage live and inactive stores.",
    subs: [
      {
        name: "Merchants",
        permissions: ["Access Merchants", "Add Merchants", "Edit Merchants"],
      },
      {
        name: "Live Store",
        permissions: [
          "Access Live Store",
          "View Live Store",
          "Edit Live Store",
          "Export Live Store",
          "Disapprove Live Store",
        ],
      },
      {
        name: "Inactive Store",
        permissions: [
          "Access Inactive Store",
          "View Inactive Store",
          "Add Inactive Store",
          "Edit Inactive Store",
          "Approve Inactive Store",
          "Export Inactive Store",
        ],
      },
      {
        name: "Refunds",
        permissions: ["Refund Request Status"],
      },
    ],
  },
  {
    id: "catalog",
    name: "Catalog & Inventory",
    desc: "Categories, duplicates and bulk inventory updates.",
    subs: [
      {
        name: "Duplicates",
        permissions: [
          "Product Duplicate",
          "Inventory Duplicate",
          "Category Duplicate",
        ],
      },
      {
        name: "Inventory",
        permissions: ["Access All Inventory Update"],
      },
      {
        name: "Default Category",
        permissions: [
          "Access Default Category",
          "Add Default Category",
          "Edit Default Category",
          "Delete Default Category",
          "Status Default Category",
        ],
      },
      {
        name: "Configure Category",
        permissions: [
          "Access Configure Category",
          "Add Configure Category",
          "Edit Configure Category",
          "Delete Configure Category",
          "Sort Configure Category",
          "Status Configure Category",
        ],
      },
    ],
  },
  {
    id: "support",
    name: "Support",
    desc: "Tickets, orders, customers and refund requests.",
    subs: [
      {
        name: "Support",
        permissions: [
          "Access Support",
          "Access Support Details",
          "Edit Support Details",
        ],
      },
      {
        name: "Orders & Customers",
        permissions: [
          "Access Order Retrieve",
          "Access Order Count",
          "Access Quickvee Customer",
          "Access Refund Request",
        ],
      },
    ],
  },
  {
    id: "marketing",
    name: "Marketing",
    desc: "SMS, newsletters, featured stores and announcements.",
    subs: [
      {
        name: "SMS",
        permissions: [
          "Bulk SMS System",
          "Restricted Keywords",
          "Add Restricted Keywords",
          "Edit Restricted Keywords",
          "Delete Restricted Keywords",
        ],
      },
      {
        name: "Newsletter",
        permissions: [
          "Access Newsletter",
          "Status Newsletter",
          "Delete Newsletter",
        ],
      },
      {
        name: "Feature Store",
        permissions: [
          "Access Feature Store",
          "Add Feature Store",
          "Edit Feature Store",
          "Delete Feature Store",
          "Sort Feature Store",
        ],
      },
      {
        name: "Feature Announcements",
        permissions: [
          "Access Feature Announcements",
          "Add Feature Announcements",
          "Edit Feature Announcements",
          "Delete Feature Announcements",
          "Status Feature Announcements",
        ],
      },
      {
        name: "Quickvee Custom",
        permissions: [
          "Access Quickvee Custom",
          "Add Quickvee Custom",
          "Edit Quickvee Custom",
          "Delete Quickvee Custom",
          "Status Quickvee Custom",
        ],
      },
    ],
  },
  {
    id: "reports",
    name: "Reports & Exports",
    desc: "Data exports for finance and analytics.",
    risk: "med",
    subs: [
      {
        name: "Exports",
        permissions: [
          "Access Inventory Export",
          "Access Product Profitability Export",
          "Access Item Wise Export",
          "Access Order Wise Export",
          "Access Customer Export",
          "Access Merchants Export",
          "Access Tip Report Export",
          "Access Purchase Order Report Export",
          "Sales by Category Per Employee - Export",
        ],
      },
    ],
  },
];

export const ROLE_PRESETS = [
  {
    id: "support",
    name: "Support",
    groups: ["merchant", "catalog", "reports"],
    extra: [
      "Access Order Retrieve",
      "Access Order Count",
      "Access Quickvee Customer",
      "Access Refund Request",
    ],
  },
  {
    id: "marketing",
    name: "Marketing",
    groups: ["marketing"],
  },
  {
    id: "it-admin",
    name: "IT/Admin",
    groups: ["admin", "merchant", "catalog", "support", "marketing", "reports"],
    exclude: ["Delete Stores"],
  },
];

const codesForPermissionNames = (names) => {
  const wanted = new Set(names.map(normalizePermissionName).filter(Boolean));
  return Object.entries(SUPERADMIN_PERMISSION_LABEL_BY_CODE)
    .filter(([, label]) => wanted.has(normalizePermissionName(label)))
    .map(([code]) => code);
};

const presetCodeSet = (role) => {
  const names = role.groups.flatMap((groupId) => {
    const group = PERMISSION_GROUPS.find((item) => item.id === groupId);
    return group ? group.subs.flatMap((sub) => sub.permissions) : [];
  });
  const codes = new Set(
    codesForPermissionNames([...names, ...(role.extra || [])])
  );
  codesForPermissionNames(role.exclude || []).forEach((code) => codes.delete(code));
  return codes;
};

const ROLE_PRESET_CODE_SETS = ROLE_PRESETS.map((role) => ({
  id: role.id,
  name: role.name,
  codes: presetCodeSet(role),
}));

export function resolveSuperadminRole(permissions) {
  const raw = Array.isArray(permissions)
    ? permissions
    : String(permissions ?? "").split(",");
  const seen = new Set();
  const knownCodes = [];

  raw.forEach((item) => {
    const code = String(item ?? "").trim();
    if (!code || seen.has(code)) return;
    seen.add(code);
    if (SUPERADMIN_PERMISSION_LABEL_BY_CODE[code]) knownCodes.push(code);
  });

  if (seen.size === 0) return { id: "none", name: "None" };
  if (knownCodes.length === 0) return { id: "custom", name: "Custom" };

  const hasEveryPermission = Object.keys(SUPERADMIN_PERMISSION_LABEL_BY_CODE).every(
    (code) => seen.has(code)
  );
  if (hasEveryPermission) return { id: "master", name: "Master" };

  // Same preset sets as Update Permission Preset. Pick the most specific
  // role whose permissions contain every code this user has.
  const match = [...ROLE_PRESET_CODE_SETS]
    .sort((a, b) => a.codes.size - b.codes.size)
    .find((role) => knownCodes.every((code) => role.codes.has(code)));

  return match
    ? { id: match.id, name: match.name }
    : { id: "custom", name: "Custom" };
}
